import { ValidationError } from 'yup';

export const newGridRecordId = 'temp';
export const newGridRecord = {
  id: newGridRecordId,
  isNew: true,
  createdDate: new Date().toISOString(),
  updatedDate: new Date().toISOString(),
};
export const formatValidation = (validationErrors: ValidationError[]) => {
  const formattedObject = validationErrors.reduce((acc, cur) => {
    if (cur.path) {
      return {
        ...acc,
        [cur.path]: cur.message,
      };
    }

    return acc;
  }, {});

  return formattedObject;
};
